import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/699d8a83f782d50014555b4e/xinyuedailynecessities/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/699d8a83f782d50014555b4e/xinyuedailynecessities/src/app/about/components/AboutContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/699d8a83f782d50014555b4e/xinyuedailynecessities/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/699d8a83f782d50014555b4e/xinyuedailynecessities/src/components/ui/AppLogo.tsx");
